// #region Custom Enumerations

// #region Download Format Enum

export enum DownloadFormat {
    PDF = 0,
    Excel = 1,
    ZIP = 2,
    VCARD = 3,
}

// #endregion

// #region Http Method Enum

export enum HttpMethod {
    GET = 0,
    POST = 1,
    POST_FORMDATA = 2,
}

// #endregion

// #endregion
